import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import DoDisturbAltIcon from "@mui/icons-material/DoDisturbAlt";
import { Box, Stack, Tooltip, Typography } from "@mui/material";

import { type Batch } from "@/schemas/routing/batch";

import { getErrorMessage } from "../error-utils";

interface AvailableBatchStatusProps {
	readonly batch: Batch;
}

export const AvailableBatchStatus: React.FC<AvailableBatchStatusProps> = ({ batch }) => {
	const intl = useIntl();

	if (batch.blockedReason === "UnableToCalculate") {
		return (
			<Typography variant="caption">
				<FormattedMessage id="Unable To Calculate" defaultMessage="Unable To Calculate" />
			</Typography>
		);
	} else if (batch.blockedReason) {
		const tooltipContent = (
			<Box sx={{ display: "flex", gap: 1.5 }}>
				<DoDisturbAltIcon fontSize="medium" sx={{ mt: 0.75 }} />
				<Box>
					<Typography variant="body2">
						<FormattedMessage id="Blocked" defaultMessage="Blocked" />
					</Typography>
					<Typography variant="caption">{getErrorMessage(batch.blockedReason, batch.alias, intl)}</Typography>
				</Box>
			</Box>
		);

		return (
			<Tooltip title={tooltipContent} arrow disableFocusListener enterTouchDelay={0}>
				<Stack direction="row" alignItems="center" spacing={1} sx={{ cursor: "pointer" }}>
					<DoDisturbAltIcon fontSize="small" />
					<Typography variant="body2">
						<FormattedMessage id="Blocked" defaultMessage="Blocked" />
					</Typography>
				</Stack>
			</Tooltip>
		);
	} else if (batch.status === "ProducingNext") {
		return (
			<Typography variant="body2">
				<FormattedMessage id="Producing Next" defaultMessage="Producing Next" />
			</Typography>
		);
	} else if (batch.status === "Triggered") {
		return (
			<Typography variant="body2">
				<FormattedMessage id="Waiting To Produce" defaultMessage="Waiting To Produce" />
			</Typography>
		);
	}

	return null;
};
